import { initEventBus } from './eventBus';

const eventBus = initEventBus();

export const posthog = {
  /**
   * Capture a custom event with optional properties
   */
  capture: (event: string, properties?: Record<string, any>) => {
    eventBus.emit('posthog:capture', { event, properties });
  },

  /**
   * Identify a user with optional properties
   */
  identify: (distinctId: string, properties?: Record<string, any>) => {
    eventBus.emit('posthog:identify', { distinctId, properties });
  },

  /**
   * Reset the PostHog instance (e.g., on logout)
   */
  reset: (resetDeviceId?: boolean) => {
    eventBus.emit('posthog:reset', { resetDeviceId });
  },
};
